module.exports = __webpack_public_path__ + "static/logo-2024-263caf602a3c6c63fa90b8f621a419e3.png";